import { useEffect, useState } from "react";
import { api } from "../api/client";

interface PortfolioResponse {
  accounts: { id: string; label: string; base_currency: string }[];
  positions: {
    id: string;
    account_id: string;
    symbol: string;
    side: string;
    quantity: number;
    avg_entry_price: number | null;
    unrealized_pnl: number | null;
  }[];
  total_value_advisory: number;
  note?: string;
}

export function Portfolio() {
  const [data, setData] = useState<PortfolioResponse | null>(null);
  useEffect(() => {
    api<PortfolioResponse>("/v1/portfolio")
      .then(setData)
      .catch(() => setData(null));
  }, []);

  if (!data) return <div className="page">Loading portfolio…</div>;

  return (
    <div className="page">
      <h1>Portfolio</h1>
      <p className="muted">{data.note ?? "Advisory values only."}</p>
      <h2>Accounts</h2>
      {data.accounts.length === 0 && <div className="muted">No linked accounts. Phase 3 will add provider linking.</div>}
      <ul>
        {data.accounts.map((a) => (
          <li key={a.id}>
            <strong>{a.label}</strong> · {a.base_currency}
          </li>
        ))}
      </ul>
      <h2>Positions</h2>
      {data.positions.length === 0 ? (
        <div className="muted">No open positions.</div>
      ) : (
        <table className="markets-table">
          <thead>
            <tr>
              <th>Symbol</th>
              <th>Side</th>
              <th className="num">Qty</th>
              <th className="num">Entry</th>
              <th className="num">PnL</th>
            </tr>
          </thead>
          <tbody>
            {data.positions.map((p) => (
              <tr key={p.id}>
                <td>{p.symbol}</td>
                <td>{p.side}</td>
                <td className="num">{p.quantity}</td>
                <td className="num">{p.avg_entry_price ?? "—"}</td>
                <td className="num">{p.unrealized_pnl ?? "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
